module.exports = __webpack_public_path__ + "static/media/griffyn4k32-rgb.c0db9e0f.png";